<template>
  <div class="menu">
    <div class="title">产品分类</div>
    <el-tree
      default-expand-all
      :data="data"
      :props="defaultProps"
      @node-click="handleNodeClick"
    ></el-tree>
  </div>
</template>

<script>
import { getProductTypeTree } from "@/api/product/type.js"

export default {
  data() {
    return {
      data: [],
      defaultProps: {
        value: "typeId",
        label: "typeName",
        children: "childrenTree",
      },
    }
  },
  methods: {
    handleNodeClick(data) {
      console.log(data)
      this.$emit("select", data)
    },
  },
  async mounted() {
    const { data } = await getProductTypeTree({
      productType: "01",
      status: "1",
      features: "01,03",
    })
    if (data) {
      data.map((record) => {
        record.typeName = `${record.typeName}(${record.proNum})`
        if (record.childrenTree) {
          record.childrenTree.map((item) => {
            item.typeName = `${item.typeName}(${item.proNum})`
            if (item.childrenTree) {
              item.childrenTree.map((menu) => {
                menu.typeName = `${menu.typeName}(${menu.proNum})`
              })
            }
          })
        }
      })
      for (let i = 0; i < data.length; i++) {
        if (data[i].proNum == 0) {
          data.splice(i, 1)
          i--
        } else if (data[i].childrenTree) {
          for (let j = 0; j < data[i].childrenTree.length; j++) {
            if (data[i].childrenTree[j].proNum == 0) {
              data[i].childrenTree.splice(j, 1)
              j--
            }
          }
        }
      }
    }
    this.data = data
  },
}
</script>

<style lang="scss" scoped>
.menu {
  background: #ffffff;
  padding: 0 0 8px 0;
  ::v-deep .el-tree {
    color: #595a5a;
  }
  // ::v-deep .expanded {
  //   color: #595a5a;
  // }
}
.title {
  margin: 0 0 8px 0;
  font-size: 14px;
  border-bottom: 1px solid #cccccc;
  padding: 8px;
}
</style>
